import { Typography, Divider } from '@mui/material';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import { FC } from 'react';

type ContentTitleSimpleProps = {
	title: string;
	id: string | undefined;
	className?: string;
	noDivider?: boolean;
};

const ContentTitleSimple: FC<ContentTitleSimpleProps> = ({
	title,
	id,
	className,
	noDivider,
}) => (
	<>
		<Typography
			variant="h5"
			component="h5"
			style={{ fontWeight: 600, letterSpacing: '0.5px' }}
			id={id}
			className={className || ''}
		>
			<FiberManualRecordIcon
				style={{ fontSize: '10px', margin: '3px 5px 3px 0' }}
				fontSize="small"
				color="secondary"
			/>
			{title}
		</Typography>
		{!noDivider && <Divider />}
	</>
);

export default ContentTitleSimple;
